var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    [
      _vm.isAdmin
        ? _c("CalendarAdmin", {
            attrs: { company: _vm.company, currentUser: _vm.currentUser },
          })
        : _c("CalendarManager", {
            attrs: {
              company: _vm.company,
              currentUser: _vm.currentUser,
              currentUserManagerId: _vm.currentUserManagerId,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }